import { PropsWithChildren } from 'react'

import { cn } from '@/shared/lib'

import { InnerLayout, OuterLayout } from './layout'

type Props = {
  className?: string
}

export const ResponsiveOuterLayout = ({
  className,
  children,
}: PropsWithChildren<Props>) => {
  return (
    <OuterLayout className={cn('max-md:w-full', className)}>
      {children}
    </OuterLayout>
  )
}

export const ResponsiveInnerLayout = ({
  className,
  children,
}: PropsWithChildren<Props>) => {
  return (
    <InnerLayout
      className={cn(
        'max-md:m-0 max-md:w-full max-md:min-w-full max-md:px-4 max-md:py-10',
        className,
      )}
    >
      {children}
    </InnerLayout>
  )
}

export const ResponsiveLayout = ({
  className,
  children,
}: PropsWithChildren<Props>) => {
  return (
    <ResponsiveOuterLayout>
      <ResponsiveInnerLayout className={className}>
        {children}
      </ResponsiveInnerLayout>
    </ResponsiveOuterLayout>
  )
}
